// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"9":"e207e9465aa84ae086b5","42":"25c625140e1884d29d10","702":"e076231cdafad3704f4d","715":"c1b74c8908e07080c3cc"}[chunkId] + ".css";
};